import {useNavigate} from 'react-router-dom';
import machineIcon from '../../../../../../assets/image/inputGroups/machinery.svg';
import {StoreOrderSteps} from '../../../../../../services/hookService/getOrderDetails/helper';
import {IStoreOrder} from '../../../../../../services/hookService/getStoreListOrder/types';
import {getPersianDateTime} from '../../../../../../utilities/helper/GetPersianDateTime';
import InfoRow from '../../../../../shopping-basket/ItemCard/InfoRow';
import ProductIcon from '../../settlementAndPayouts/components/ProductIcon';
import {MyStoreOrderTabsType} from '../storeOrderTabsConfig';
import {AllPaymentTypeToPersian} from '../../../../../shopping-basket/cash-payment/utils/helpers';

interface IProps {
  storeOrder: IStoreOrder;
  parentOrderGuid: string;
  selectedTab?: MyStoreOrderTabsType;
}

const MyStoreOrderItem = ({
  storeOrder,
  parentOrderGuid,
  selectedTab,
}: IProps) => {
  const navigate = useNavigate();

  const handleOrderClick = () => {
    switch (true) {
      // Do not route if canceled
      case selectedTab === 'canceled':
        break;

      default:
        navigate(`/my-store-order-detail/${parentOrderGuid}`);
        break;
    }
  };

  const storeOrderStep = storeOrder.step as StoreOrderSteps;

  return (
    <div className="relative space-y-3 cardItem" onClick={handleOrderClick}>
      {/* Product Images */}
      <div className="grid grid-cols-3 w-[70%] gap-2 py-2 justify-items-start">
        {storeOrder.order_items.map(item => (
          <ProductIcon
            key={item.guid}
            icon={item.image ?? item.sub_brand_image ?? machineIcon}
            count={item.quantity}
          />
        ))}
      </div>

      {selectedTab === 'canceled' && (
        <div className="absolute px-2.5 py-1 text-sm text-red-600 rounded-2xl top-2 left-5 bg-red-50">
          لغوشده
        </div>
      )}

      {selectedTab === 'delivered' &&
        storeOrderStep === StoreOrderSteps.SHIPPED && (
          <div className="absolute px-2.5 py-1 text-sm text-blue-500 rounded-2xl top-2 left-5 bg-blue-50">
            ارسال شده
          </div>
        )}

      {selectedTab === 'delivered' &&
        storeOrderStep !== StoreOrderSteps.SHIPPED && (
          <div className="absolute px-2.5 py-1 text-sm text-farm-shop-600 rounded-2xl top-2 left-5 bg-farm-shop-50">
            دریافت شده
          </div>
        )}

      <InfoRow
        icon="icon-nameCalendar"
        label="تاریخ ثبت سفارش"
        value={getPersianDateTime(storeOrder.created_at) ?? 'تاریخ نامعین'}
      />

      {selectedTab === 'canceled' ? (
        <InfoRow
          icon="icon-nameCalendar"
          label="تاریخ لغو سفارش"
          value={getPersianDateTime(storeOrder?.rejected_at) ?? 'تاریخ نامعین'}
        />
      ) : (
        <InfoRow
          icon="icon-nameCalendar"
          label="تاریخ تامین سفارش"
          value={getPersianDateTime(storeOrder?.supply_date) ?? 'تاریخ نامعین'}
        />
      )}

      {Boolean(storeOrder?.payment_type) && selectedTab !== 'canceled' && (
        <InfoRow
          icon="icon-nameWallet-out"
          label="نوع پرداخت"
          value={AllPaymentTypeToPersian[storeOrder?.payment_type]}
        />
      )}
    </div>
  );
};

export default MyStoreOrderItem;
